import { Route, Routes } from "react-router-dom";

import LayoutOutlet from "../layouts/layoutOutlet";
import LandingPage from "../pages/landingPage";
import NotFoundPage from "../pages/notFoundPage";
import AIServicesPage from "../pages/services/AIServicesPage";
import GameServicesPage from "../pages/services/gameServicesPage";
import DigitalServicesPage from "../pages/services/digitalServicesPage";
import CaseStudiesPage from "../pages/caseStudiesPage";
import DigitalStudioPage from "../pages/digitalStudioPage";
import AboutUsPage from "../pages/aboutUsPage";
import ContactUsPage from "../pages/contactUsPage";
import CareersPage from "../pages/careersPage";
import JobDetailsPage from "../pages/jobDetailsPage";
import BlogsPage from "../pages/blogsPage";
import BlogDetailsPage from "../pages/blogDetailsPage";
import PrivacyPolicyPage from "../pages/privacyPolicyPage";
import TermsNConditionsPage from "../pages/termsNConditionsPage";

import { Outlet } from "react-router-dom";

const Router = () => {
    return(
        <Routes>
            <Route path="/" element={<LayoutOutlet />}>
                <Route index element={<LandingPage />} />

                <Route path="/suite" element={<Outlet />}>
                    <Route index element={<AIServicesPage />} />
                    <Route path="ai" element={<AIServicesPage />} />
                    <Route path="games" element={<GameServicesPage />} />
                    <Route path="digital" element={<DigitalServicesPage />} />
                </Route>
                
                <Route path="case-studies" element={<CaseStudiesPage />} />
                <Route path="digital-studio" element={<DigitalStudioPage />} />
                <Route path="about-us" element={<AboutUsPage />} />
                <Route path="contact-us" element={<ContactUsPage />} />
                <Route path="careers" element={<CareersPage />} />
                <Route path="careers/:job" element={<JobDetailsPage />} />
                <Route path="blogs" element={<BlogsPage />} />
                {/* <Route path="blogs/:id" element={<BlogDetailsPage />} /> */}

                <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
                <Route path="terms-and-conditions" element={<TermsNConditionsPage />} />

                <Route path="*" element={<NotFoundPage />} />
            </Route>
        </Routes>
    );
}

export default Router;